<template>
  <div id='index' v-if="body_show">
    <!-- 邀请返现 -->
    <div class="share" v-if="(data.shareinfo || is_red) && shareshow">
      <img src="@a/sha2.png" class="close" alt="" @click="shareshow=false" />
      <div class="clearfix"></div>
      <div v-if="data.shareinfo">
        <h2><span class="text-ellipsis">{{data.sharenickname}}</span>发起的邀请</h2>
        <div class="share_per clearfix">
          <div class="sp_l">
            <img :src="data.shareheadimgurl" alt="" />
            <p class="text-ellipsis">{{data.sharenickname}}</p>
          </div>
          <img src="@a/sha1.png" alt="" class="lj_img" />
          <div class="sp_l">
            <img :src="headImg" alt="" />
            <p class="text-ellipsis">{{data.userdetail.nickname}}</p>
          </div>
        </div>
        <div class="sp_b clearfix">
          <span><span>￥</span>{{data.shareprice}}</span>
          <div class="sp_br">
            <h3>好友邀请为你节省{{data.shareprice}}元</h3>
            <h4 v-if="data.shareend">有效日期：{{data.shareend}}</h4>
            <h4 v-else>{{data.sharestart}}</h4>
          </div>
        </div>
      </div>
      <div class="sp_b clearfix" v-if="is_red && data.otheractivity">
        <span><span>￥</span>{{data.redPrice.use_money}}</span>
        <div class="sp_br">
          <h3 class="text-ellipsis">{{data.redPrice.describe}}</h3>
          <h4>有效日期：{{data.redPrice.start_time}}-{{data.redPrice.end_time}}</h4>
        </div>
      </div>
    </div>
    <!-- 公用头部 -->
    <public-header :colors="'#fff'" :routArg="routArg" :headimg="headImg"></public-header>
    <!-- banner -->
    <img src="@a/banner_new.png" width="100%">
    <!-- 价格和时间 -->
    <div class="money_box" v-if="!data.ishavedbuy">
      <div class="money_">
        <div class="money_left" v-if="surplusPriceTime>0">优惠价：<span>¥{{courseprice}}</span></div>
        <div class="money_left" v-else>价格：<span>¥{{originalprice}}</span></div>
        <div class="money_time" v-if="surplusPriceTime>0">倒计时 <span>{{day}}</span> 天 <a>{{time}}</a>
          <br/>恢复原价 <span>{{originalprice}}</span> 元</div>
        <!-- <div class="money_time money_time1" v-else><span>5000+ </span>学员好评推荐</div> -->
        <div class="money_right" v-else>
          6000+职场人好评推荐
        </div>
      </div>
      <div class="mev clearfix">
        <van-radio-group :class="['radio_group',!item.sign?'radio_group_over':'']" v-for="(item,index) in data.list" :key="index" v-model="radio" :disabled="!item.sign?true:false">
          <van-radio :name="item.id">
            {{item.course_begintime_str}}入营
          </van-radio>
        </van-radio-group>
      </div>
    </div>
    <div class="money_box" v-else>
      <!-- <div class="money_">
        <div class="money_left">优惠价：<span>¥{{data.courseprice}}</span></div>
        <div class="money_right">原价{{data.originalprice}}，限时优惠{{(data.originalprice*100-data.courseprice*100)/100}}</div>
      </div> -->
      <div class="money_">
        <div class="money_left" v-if="surplusPriceTime>0">优惠价：<span>¥{{courseprice}}</span></div>
        <div class="money_left" v-else>价格：<span>¥{{originalprice}}</span></div>
        <div class="money_time" v-if="surplusPriceTime>0">倒计时 <span>{{day}}</span> 天 <a>{{time}}</a>
          <br/>恢复原价 <span>{{originalprice}}</span> 元</div>
        <div class="money_right" v-else>
          6000+职场人好评推荐
        </div>
      </div>
      <div class="date_ date_now" v-for="(item,index) in data.list" :key="index">{{item.course_begintime_str}}开营&nbsp;&nbsp;已购</div>
      <div :class="['date_',!item.sign?'date_over':'']" v-for="(item,index) in data.buyList" :key="index">{{item.course_begintime_str}}入营</div>
      <div class="clearfix"></div>
    </div>
    <public-spell :scrabble="scrabble" :ishavedbuy="data.ishavedbuy" v-if="scrabble"></public-spell>
    <!-- 职业困扰 -->
    <div class="problem_">
      <div class="problem_box">
        <!--职业问题困扰标题-->
        <h2 class="btb1">在想要职业快速发展的上升期<span></span></h2>
        <h2 class="btb2">90%的职业人都会被以下问题困扰！<span></span></h2>
        <!--职业问题困扰模块-->
        <div class="problem_list">
          <div class="problem_child">
            <img src="@a/problem1_new.png" />
            <p>向上发展的职位和机会开始变少，单单靠拼时间、拼努力，<span>已经不能快速提升自己身价。</span></p>
          </div>
          <div class="problem_child">
            <img src="@a/problem2_new.png" />
            <p>对未来的发展方向重新定位，开始思考：<span>现在做的事情是不是最合适？还有没有其他更好的选择？</span></p>
          </div>
        </div>
        <div class="problem_list p_list">
          <div class="problem_child">
            <img src="@a/problem3_new.png" />
            <p>零零散散做了许多事情，能力有提升，也取得了一些成绩，但是<span>希望更清晰自己的核心竞争力。</span></p>
          </div>
          <div class="problem_child">
            <img src="@a/problem4_new.png" />
            <p>局限于自己<span>眼前的选择</span>，对于<span>整个行业环境</span>、趋势不了解，<span>不知道自己的发展路径还有哪些可能性。</span></p>
          </div>
        </div>
        <!--这些困扰-->
        <div class="problem_box_child">
          <p>这些<span>困扰</span></p>
          <p>在埋头向前冲时经常隐形</p>
          <p>但总会在某个<span>加班的夜晚</span>再次出现</p>
          <p>让你<span>反复纠结和内耗</span></p>
          <img src="@a/bottom_new.png" />
        </div>
        <!--其实你需要-->
        <div class="need_box">
          <h2>其实你需要</h2>
          <h3>深入了解自身优势 & 更高维度理解职业和趋势<br/>为自己设计一套能快速发展的职业解决方案</h3>
        </div>
        <!--个人战略价值重塑-->
        <div class="restore_box">
          <h2>个人战略·商业价值重塑</h2>
          <div class="restore_list">
            <div class="restore_group">
              <img src="@a/restore1_new.png" />
              <h4>帮你找准定位</h4>
            </div>
            <div class="restore_group">
              <img src="@a/restore2_new.png" />
              <h4>设计发展路径</h4>
            </div>
            <div class="restore_group">
              <img src="@a/restore3_new.png" />
              <h4>提高职场身价</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--导师寄语-->
    <div class="problem_">
      <div class="problem_box">
        <!--职业问题困扰标题-->
        <h2 class="btb2 btb_new1">著名生涯规划师90天潜心研发</h2>
        <h2 class="btb2 btb_new2">跟着顶尖个人职业发展顾问古典老师一起学习!</h2>
        <!--导师信息-->
        <div class="mentorInformation">
          <img src="@a/gudian_new.png" />
          <div class="mentorInformation_text">
            <h3>项目研发&课程导师 / 古典</h3>
            <p>新精英生涯创始人，著名生涯规划师，顶尖个人职业发展顾问</p>
            <p>众多知名企业高管教练，得到专栏《超级个体》主理人</p>
            <p>所著书籍《拆掉思维里的墙》《你的生命有什么可能》《跃迁：成为高手的技术》畅销300万册</p>
          </div>
        </div>
        <div class="yhx"></div>
        <div class="dsjy">
          <p>“在跑出生存期后，突破自我瓶颈，抬头看路，变的前所未有的重要——你应该知道自己未来要去哪，值多少钱，以及该如何有步骤的提升，并链接上对于未来的关键资源。这门课就是要成为职场人发展的加速器。”</p>
          <p class="pr">——导师寄语</p>
        </div>
      </div>
    </div>
    <!--PBL发展方向-->
    <div class="problem_">
      <div class="problem_box">
        <h2 class="btb2 btb_new3">国内首个采用PBL（Project Based Learning）</h2>
        <h2 class="btb2 btb_new1">项目制学习方式的职场课程</h2>
        <h2 class="btb2 btb_new2">30天高强度项目学习，获得清晰职业发展方向</h2>
        <!--发展方向模块-->
        <div class="direction_box_one">
          <div class="direction_child">
            <img src="@a/direction1_new.png" />
            <h4><span>4</span>大<br/>加速项目</h4>
          </div>
          <div class="direction_child">
            <img src="@a/direction2_new.png" />
            <h4><span>20</span>堂<br/>必修课程</h4>
          </div>
          <div class="direction_child">
            <img src="@a/direction3_new.png" />
            <h4>教练助教<br/>督学体系</h4>
          </div>
        </div>
        <!--发展方向模块2-->
        <div class="direction_box_two">
          <div class="direction_child">
            <img src="@a/direction4_new.png" />
            <h4><span>7</span>人小组<br/>通力协作</h4>
          </div>
          <div class="direction_child">
            <img src="@a/direction5_new.png" />
            <h4><span>8</span>次<br/>线上讨论</h4>
          </div>
          <div class="direction_child">
            <img src="@a/direction6_new.png" />
            <h4><span>12</span>个<br/>内部工具</h4>
          </div>
          <div class="direction_child">
            <img src="@a/direction7_new.png" />
            <h4><span>4</span>大专属<br/>战略报告</h4>
          </div>
        </div>
        <!--发展阶段-->
        <h2 class="fzjd"><img src="@a/direction_icon.png" />4大真实项目——快速到达职业发展新阶段</h2>
        <div class="fzjd_box">
          <h2>问题，是学习的起点，而解决问题，是提升能力的最佳方式。</h2>
          <p>不同于传统课程的单纯知识传输，「个人战略」课全程围绕项目任务展开，以”做到“为目标，让每一位学员都能拿到对自己职业发展有益的项目报告，往期项目完成率超过90%。</p>
        </div>
        <!---->
        <div class="development_ul">
          <ul>
            <li>
              <div class="ul_border"><span class="bdf bd_one"><span class="bdc bd_one"></span></span>
              </div>
              <div class="development_ul_group no_mt">
                <h2>项目零  项目学习引导</h2>
                <p>导览完整项目，完成<span class="bold">7人制小组组建</span></p>
                <p>完成个人<span class="bold">战略10问，挖掘内心</span>渴望</p>
              </div>
            </li>
            <li>
              <div class="ul_border"><span class="bdf"><span class="bdc"></span></span>
              </div>
              <div class="development_ul_group">
                <h2>项目一  职业赛道调研</h2>
                <p>研究行业赛道，明确快速增长的<span class="bold">行业趋势</span></p>
                <p>梳理<span class="bold">个人定位</span>，锁定自己的职场坐标</p>
                <p>探索<span class="bold">3条</span>可能<span class="bold">职业路径</span>，明晰相应能力要求与职业回报</p>
              </div>
            </li>
            <li>
              <div class="ul_border"><span class="bdf"><span class="bdc"></span></span>
              </div>
              <div class="development_ul_group">
                <h2>项目二  对标人物研究</h2>
                <p>精选自己的职场榜样，研究Ta的<span class="bold">成长之路</span></p>
                <p>完成榜样对标分析，学习高手的<span class="bold">发展策略</span></p>
                <p>掌握跨越生涯拐点所需的<span class="bold">底层认知</span></p>
              </div>
            </li>
            <li>
              <div class="ul_border"><span class="bdf"><span class="bdc"></span></span>
              </div>
              <div class="development_ul_group">
                <h2>项目三  分析内在优势与探索职业目标</h2>
                <p>挖掘自身成就事件，分析自身能力<span class="bold">优势和职业驱动力</span></p>
                <p>结合内外部研究结果，重新定义自己未来<span class="bold">2-3年的职业目标</span></p>
                <p>全面盘点职业现状，定位当下职业<span class="bold">发展核心破局点</span></p>
              </div>
            </li>
            <li>
              <div class="ul_border"><span class="bdf"><span class="bdc"></span></span>
              </div>
              <div class="development_ul_group">
                <h2>项目四  制定个人发展路书与个人战略地图</h2>
                <p>设计未来2-3年的<span class="bold">职业发展路径</span>，并评估风险和障碍点</p>
                <p>制定针对目标职业的可执行<span class="bold">能力成长计划</span></p>
                <p>复盘整体项目，完成<span class="bold">个人发展路书与个人战略地图</span></p>
              </div>
            </li>
          </ul>
          <!---->
          <h2 class="fzjd"><img src="@a/direction_icon.png" />20堂职场发展必修课程，古典老师亲自讲授</h2>
          <ul>
            <li>
              <div class="ul_border"><span class="bdf bd_one"><span class="bdc bd_one"></span></span>
              </div>
              <div class="development_ul_group no_mt">
                <h2>项目零  项目学习引导</h2>
                <p>L1 战略思维是优秀人的<span class="bold">底层思维</span></p>
                <p>L2 制定个人路书，兑现<span class="bold">商业价值</span></p>
                <p>L3 直面与解决问题</p>
                <p>L4 如何有<span class="bold">策略</span>的深度学习</p>
              </div>
            </li>
            <li>
              <div class="ul_border"><span class="bdf"><span class="bdc"></span></span>
              </div>
              <div class="development_ul_group">
                <h2>项目一  职业赛道调研</h2>
                <p>L1 战略六字要诀：<span class="bold">盯需求、做稀缺</span></p>
                <p>L2 价值判断：怎样找到<span class="bold">高回报</span>的机会</p>
                <p>L3 设计发展路径的<span class="bold">4种</span>方式</p>
                <p>L4 核心竞争力：你和你解决的问题</p>
              </div>
            </li>
            <li>
              <div class="ul_border"><span class="bdf"><span class="bdc"></span></span>
              </div>
              <div class="development_ul_group">
                <h2>项目二  对标人物研究</h2>
                <p>L1 对标Ta，找到自己的<span class="bold">最优路径</span></p>
                <p>L2 四步对标法，抓住机会</p>
                <p>L3 三层幕布，<span class="bold">深度洞察</span>世界</p>
                <p>L4 傅盛和他的认知三部曲</p>
              </div>
            </li>
            <li>
              <div class="ul_border"><span class="bdf"><span class="bdc"></span></span>
              </div>
              <div class="development_ul_group">
                <h2>项目三  分析内在优势与探索职业目标</h2>
                <p>L1 个人<span class="bold">战略全景图</span></p>
                <p>L2 10问自己，落地个人战略</p>
                <p>L3 通过成就事件，<span class="bold">挖掘个人优势</span></p>
                <p>L4 职业体检，<span class="bold">重塑</span>你的职业目标</p>
              </div>
            </li>
            <li>
              <div class="ul_border"><span class="bdf"><span class="bdc"></span></span>
              </div>
              <div class="development_ul_group">
                <h2>项目四  制定个人发展路书与个人战略地图</h2>
                <p>L1 职业发展路书设计</p>
                <p>L2 个人成长计划，<span class="bold">提升生涯内功</span></p>
                <p>L3 一张地图，总览<span class="bold">个人战略</span></p>
                <p>L4 一个故事，一个行动</p>
              </div>
            </li>
          </ul>
          <!---->
          <h2 class="fzjd"><img src="@a/direction_icon.png" />职场教练全程服务指导，真正为学习效果负责</h2>
          <div class="direction_book_box">
            <div class="book_box_left">
              <span class="bw">项目教练均为拥有国家认证资质的生涯规划师</span>（课程外单次咨询价格每小时500元起），在<span class="bw">30天</span>项目时间里将<span class="bw">全程支持与陪伴成为你的专属职场教练。</span>
            </div>
            <div class="book_box_right">
              <h3>针对性答疑</h3>
              <h3>1对1点评项目作业</h3>
              <h3>带领小组交流讨论</h3>
            </div>
          </div>
          <div class="dir_box">
            <img src="@a/direction_img.png" class="dir_img" />
            <p>图：生涯规划师认证证书</p>
          </div>
          <!--7人小组学习体系-->
          <h2 class="fzjd"><img src="@a/direction_icon.png" />7人小组学习体系——基于共同目标的深度合作</h2>
          <p class="dir_box_two">
            根据入学资料，会将行职业相关、能力相当的7位同学分为一组，同时匹配一位专属助教。<span>30天时间，助教全程协助小组成员完成项目和讨论。</span>
          </p>
          <div class="team_box">
            <p class="dir_box_two">
              小组讨论是<span>PBL</span>学习中，最重要也是最有趣的一个环节 。
            </p>
            <p class="dir_box_two">
              每个人拥有特定角色，每周<span>2次线上高效讨论，结识高质量人脉</span>
            </p>
            <img src="@a/direction_img2.png" />
          </div>
          <!--12个内部工具首次公开—加速个人发展的独家利器-->
          <h2 class="fzjd"><img src="@a/direction_icon.png" />12个内部工具首次公开—加速个人发展的独家利器</h2>
          <div class="tool_box">
            <h3>行职业调研模板</h3>
            <h3>职业发展路径分析报告</h3>
            <h3>个人身价评估方式</h3>
            <h3>对标人物三层幕布分析</h3>
            <h3>职业认知与价值观探索</h3>
            <h3>个人成就事件分析</h3>
            <h3>个人优势与驱动力探索 </h3>
            <h3>职业目标重塑 </h3>
            <h3>职业破局点分析 </h3>
            <h3>职业发展路书</h3>
            <h3>个人能力成长计划</h3>
            <h3>个人战略地图</h3>
          </div>
        </div>
      </div>
    </div>
    <!--课程适合谁-->
    <div class="problem_">
      <div class="problem_box shs">
        <h2 class="btb2 btb_new1_shs">课程适合谁？</h2>
        <p>想明确发展路径，准确自我定位的人</p>
        <p>想提升核心竞争力，探索自身深层优势的人</p>
        <p>想提高身价，找到方法和最短路径的人</p>
        <p>想跳槽换工作，高效选择新机会的人</p>
      </div>
    </div>
    <!--往期学员告诉你-->
    <div class="problem_">
      <div class="problem_box">
        <h2 class="btb2 btb_new2_shs">往期学员想告诉你</h2>
        <div class="student_box">
          <img src="@a/students1_new.png" />
          <div class="student_content">
            <div class="student_head">
              <h3>学员：王曦</h3>
              <h3 class="stu_r">网易懒人听书签约讲师</h3>
            </div>
            <div class="stu_content">
              看得见未来才有未来。古典老师的个人战略课程，以更高的视角帮助学员规划一条对个人来说具有战略意义的发展道路。不同于单纯的知识付费课程学过就忘，《个人战略》训练营把学习课程、任务、学习小组结合，甚至提供了多种测试工具，帮助个人更科学的完成个人战略规划，这种训练式和陪伴式学习，确保让每个人的深度吸收和即学即用，受益匪浅。
            </div>
          </div>
        </div>
        <div class="student_box">
          <img src="@a/students2_new.png" />
          <div class="student_content">
            <div class="student_head">
              <h3>学员：畅畅</h3>
              <h3 class="stu_r">影视流程技术指导</h3>
            </div>
            <div class="stu_content">
              这几年一直感觉自己在错误的方向越跑越远，而且不知道怎么停下来，焦虑又痛苦。《个人战略》课程让我难得有机会停下来，思考自己的初心。在和组员分析成就事件的过程中，我也慢慢接纳了自己的特别之处，制定出可落地的发展路书。回想整个课程，是“拓展视野”’、“信仰充值”、“找回初心”、“接纳自我”的一个月，我在这里找到了关于未来的答案，相信你也可以。
            </div>
          </div>
        </div>
        <div class="student_box">
          <img src="@a/students3_new.png" />
          <div class="student_content">
            <div class="student_head">
              <h3>学员：李东霖</h3>
              <h3 class="stu_r">来自51talk </h3>
            </div>
            <div class="stu_content">
              个人战略课比一般线上课程有更落地的行动，比一般社群有更深层次的链接，是一个选择了就不会后悔的课程。在课程中找到自己的定位，在行动中清晰自己的目标，在讨论中重塑个人商业价值，这一路就像寻宝一样，总是有未知的惊喜在等着你。这一路并不孤单，助教、组员，每一个人都是成长路上的同伴。
            </div>
          </div>
        </div>
        <div class="student_box">
          <img src="@a/students4_new.png" />
          <div class="student_content">
            <div class="student_head">
              <h3>学员：李恒逸</h3>
              <h3 class="stu_r">人工智能研发工程师</h3>
            </div>
            <div class="stu_content">
              我是得到、混沌大学、樊登读书会等知识付费产品的会员，看到产品模式（PBL小组教学）比较新鲜，就购买了一期课程。我本来的期望也很简单，有所收获就好，结果一期课程下来，我的感受只能用一个字形容：爽！我想告诉你们，其实这并不是一套课程，而是你和一群各具优点的人的一场场头脑风暴，学完之后，收获的不仅仅是观点，还是和高质量人群的高质量链接。期待你能来加入这场PBL的盛会！
            </div>
          </div>
        </div>
        <div class="student_box">
          <img src="@a/students5_new.png" />
          <div class="student_content">
            <div class="student_head">
              <h3>学员：马小格</h3>
              <h3 class="stu_r">准妈妈</h3>
            </div>
            <div class="stu_content">
              我在面对自己准妈妈的新身份的时候，开始重新思考自己工作5年的职场发展。看了很多书，可是面对现实的复杂情况，我一个人的摸索遇到很多问题。在一个月的课程学习中，我深刻认识到努力和正确方向的努力的差距。如果你还在犹豫，推荐你先行动起来。用”做到“代替”思考“，用行动收获属于你的“个人战略”。
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--加入我们-->
    <div class="problem_">
      <div class="problem_box join_us">
        <p>独立、系统的思考个人发展</p>
        <p>是每个行业大神和高手的必修课</p>
        <p>这种能力，是他们一次次突破形成跃迁的关键能力</p>
        <h2 class="btb2 ">既然你每个月都花10小时看电影、见朋友和发呆</h2>
        <h2 class="btb2 ">为什么不用同样的时间来思考下自己的发展？</h2>
        <h2 class="btb2 btb_new_join">决胜未来2年的人生？</h2>
        <h3>加入我们，领跑你的同龄人！</h3>
        <img src="@a/bottom_new.png" />
      </div>
    </div>
    <!--常见问题-->
    <div class="common_box">
      <h2>常见问题</h2>
      <ul>
        <li>
          <img style="margin-top: 0;" src="@a/commonn_problems.png" />
          <div class="common_box_text">
            <h3 style="margin-top: 0;">整体的学习方式是怎样的？</h3>
            <p>「个人战略」课，学习过程采取音频课程+项目作业+小组讨论+1对1点评+在线答疑的形式，学员可以自主安排音频学习时间，但需在规定的学习周期内完成项目作业并参加线上讨论。</p>
          </div>
        </li>
        <li>
          <img src="@a/commonn_problems.png" />
          <div class="common_box_text">
            <h3>学习周期有多长？</h3>
            <p>课程由开营项目P0和4个主要项目构成，主要项目每周学习并完成一个，学习时长30天。</p>
          </div>
        </li>
        <li>
          <img src="@a/commonn_problems.png" />
          <div class="common_box_text">
            <h3>课程是否可以一直观看？</h3>
            <p>课程音频及项目作业可永久观看。</p>
          </div>
        </li>
        <li>
          <img src="@a/commonn_problems.png" />
          <div class="common_box_text">
            <h3>学习中如果遇到问题怎么办？</h3>
            <p>学习过程中如遇到问题，可通过以下渠道沟通或求助： 1.联系助教、教练、或班主任；2.通过小组及班级讨论解决。</p>
          </div>
        </li>
        <li>
          <img src="@a/commonn_problems.png" />
          <div class="common_box_text">
            <h3>课程不合适或时间不合适，可以延期或退款吗？</h3>
            <p>报名后开营前，如遇时间不合适可向班主任提出延期/退款申请，延期只可申请一次；本产品为虚拟内容服务，购买后申请过延期或者开营后概不退款，请您审慎下单并予以理解。<span style="color: orange; font-weight: bold;">另，购买本课程即赠送精品小课兑换码，若用户于使用兑换码后申请退款，需扣除精品小课相应费用。</span></p>
          </div>
        </li>
      </ul>
    </div>
    <div class="banq">
      * 本课程由新精英生涯（北京）教育科技有限公司版权所有，违者必究
    </div>
    <!-- 按钮 -->
    <div class="into_btn_box">
      <div class="into_btn" v-if="!data.ishavedbuy">
        <div class="into_btn_spe" v-if="scrabble">
          <a class="free_learn spell" href="javascript:;">早鸟价￥{{originalprice}}<br/><span>仅剩席位:{{surplus}}</span></a>
          <router-link class="sign_immediately" :to="'/course_spell?scrabble_type=create&bid=' + data.bid" v-if="surplus>0">
            发起拼团 ￥{{scrabble.price}}</b>
          </router-link>
          <a class="sign_immediately sign_immediatelys" v-else>
            本期已满</b>
          </a>
        </div>
        <div class="into_btn_spe" v-else>
          <a class="free_learn" @click="free_learn" href="javascript:;">免费试学</a>
          <a class="sign_immediately only" @click="signHandle" v-if="surplus>0">
            立即报名&nbsp;&nbsp;<span>仅剩席位:{{surplus}}</span><b>报名截止时间: {{begintime}}</b>
        </a>
          <a class="sign_immediately sign_immediatelys" v-else>本期已满</a>
        </div>
      </div>
      <a v-else>
        <router-link class="into_project" v-if="scrabble && scrabble.is_leader" :to="'/course_spell?scrabble_type=invite&scrabble_id=' + scrabble.scrabble_id">邀请好友拼团</router-link>
        <router-link class="into_project" v-else :to="url_substying(data.ishavedbuy) + '?cid=' + cid">进入【项目】</router-link>
      </a>

    </div>
    <van-popup v-model="share_show" position="bottom">
      <div class="share_order">
        <img src="@a/sha2.png" class="close" alt="" @click="share_show=false" />
        <div class="clearfix"></div>
        <h2>订单详情</h2>
        <h3 class="clearfix">课程价格<span>￥{{courseprice}}</span></h3>
        <van-radio-group class="order_group" v-for="(item,index) in order_group" :key="index" v-model="use_id">
          <van-radio :name="item.id">
            {{item.name}}<span>- ￥{{item.price}}</span>
          </van-radio>
        </van-radio-group>
        <a class="into_project" @click="signHandle" v-if="typeof use_id === 'string' || typeof use_id === 'number'">立即付款 ￥{{order_price}}</a>
        <a class="into_project into_project_over" v-else>立即付款</a>
      </div>
    </van-popup>
    <!-- 引入卡片弹窗 -->
    <public-pop v-if="$route.query.bid" :imgUrl="data.sharebuy_placard" :cid="cid" :text_assistant="'长按添加助理<br/>领取更多'" :insert_text="'课程资料'" :text_card="'长按保存分享，每入学1位您可获得80元奖学金'" :type="1"></public-pop>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="cid" :use_id="use_id" :source="source" :sharetype="sharetype" :type="'course'" :pdk="pdk" :aspx="aspx" @statistic_="statistic_"></public-mobile>
    <public-ewm :assistant_show="assistant_show" :ewm_img="ewm_img"></public-ewm>
    <!-- 红包 -->
    <van-popup class="prize-pop" v-model="showPrize" :close-on-click-overlay="false">
      <div :class="[prizeBg ? 'show' : '', 'prize pr']">
        <div @click="pull_click" class="close-btn"></div>
        <div class="bg pr">
          <div v-if="!prizeBg" class="pr">
            <img @click="prizeBg_click" class="prize-btn" src="@a/Prize_btn.png" alt="" />
            <!-- <img style="opacity: 1;" src="@a/Prize_bg (2).png" alt="" /> -->
            <p class="text-tip row-public">{{data.redPrice.name}}</p>
            <img class="logo_top reward_logo" src="@a/course_reward_logo.png" />
            <p class="tip-footer row-public row-spe">- 好好学习，天天向上 -</p>
          </div>
          <div v-else>
            <p class="h1-head row-public">恭喜您获得</p>
            <p class="row-public greet">{{describe}}</p>
            <div class="num pa" style="width: 100%;">
              <p class="h2-row row-public"><span class="num-type">￥</span>{{money}}</p>
              <p class="size-sm row-public">可用于抵扣课程学费</p>
            </div>
            <img class="logo_bottom reward_logo" src="@a/course_reward_logo.png" alt="" />
            <p class="tip-footer row-public">- 好好学习，天天向上 -</p>
          </div>
          <img style="opacity: 1;" src="@a/Prize_bg (1).png" alt="" />
          <!-- bg -->
        </div>
      </div>
    </van-popup>
    <van-popup v-model="big_show" class="pop_assistant">
      <div class="pop_assistant_box">
        <img :src="bigqrcode" />
        <h3><span>扫码进群</span><br/><span>领取 </span> <span class="on">免费试学</span> <span> 名额</span><br/><span>还有限时福利！</span></h3>
      </div>
    </van-popup>
    <!-- 未关注弹窗 -->
    <van-popup :close-on-click-overlay="false" v-model="not_concern" class="pop_assistant">
      <div class="pop_assistant_box">
        <h3 style="font-weight: bold">{{data.userdetail.nickname}}你好！您已成功报名{{data.coursename}}，为了不和组织失联，请关注下方二维码。</h3>
        <h4>识别或扫描二维码</h4>
        <img src="@a/carrer.png" />
        <h4>已关注的看官自动忽略</h4>
      </div>
    </van-popup>
    <!-- 过年春节弹窗-->
    <!-- <van-popup  v-model="spring_festival" class="Spring-Festival">
      <div class="box">
        <img src="@a/grzl.png" alt="">
      </div>
    </van-popup> -->
  </div>
</template>
<script>
import {
  isMain
} from '@/utils/tools'
import {
  statistics
} from "@/api/public";
import {
  coursedetail,
  grabRed,
  getproject
} from "@/api/course"
import {
  project_click_time
} from "@/api/course"
import {
  statistic_next
} from "@/api/course"
import {
  shareCon
} from "@/utils/wxconfig";
import {
  getStorage,
  setStorage
} from "@/utils/tools"
let xx = require("../../../assets/carrer.png");
export default {
  data() {
      return {
        showPrize: false,
        prizeBg: false,
        money: "",
        describe: "",
        pblname: "pl",
        name: "",
        music: "",
        body_show: false,
        cid: null,
        headImg: "",
        data: {},
        phone: null,
        source: '',
        pdk: '',
        aspx: '',
        assistant_show: false,
        ewm_img: "",
        routArg: {},
        courseprice: null,
        originalprice: null,
        surplus: null,
        radio: '',
        shareshow: true,
        share_show: false,
        is_red: false,
        order_group: [],
        use_id: null,
        order_price: '',
        big_show: false,
        bigqrcode: '',
        free_show: false,
        sharetype: "",
        timestamp: '',
        time: '',
        day: 0,
        not_concern: false,
        begintime: '',
        is_showtext: false,
        scrabble: false,
        spring_festival:true
      }
    },
    watch: {
      radio(curVal, oldVal) {

        // 修改课程期数
        for (let arg of this.data.list) {
          if (arg.id == curVal) {
            let timestampcha = Date.parse(new Date()) / 1000 - this.timestamp;
            this.surplusPriceTime = arg.surplusPriceTime - timestampcha;
            this.courseprice = arg.courseprice;
            this.originalprice = arg.originalprice;
            this.surplus = arg.surplus;
            this.begintime = arg.begintime;
            if (this.use_id != '') {
              this.order_price = (this.courseprice * 100 - this.data.redPrice.use_money * 100) / 100;
            } else {
              this.order_price = (this.courseprice * 100 - this.data.shareprice * 100) / 100;
            }
          }
        };
        clearInterval(this.sin);
        this.timeTostring();
        this.cid = String(curVal);
      },
      use_id(curVal, oldVal) {
        if (curVal != '') {
          this.order_price = (this.courseprice * 100 - this.data.redPrice.use_money * 100) / 100;
        } else {
          this.order_price = (this.courseprice * 100 - this.data.shareprice * 100) / 100;
        }
      }
    },
    methods: {
      set_session(key, value) {
        let session = window.sessionStorage;
        if (!session) {
          // 会话缓存
          if (!Vue.prototype._session) {
            Vue.prototype._session = {};
          }
          session = Vue.prototype._session;
        }
        session[key] = value;
      },
      get_session(key) {
        let session = window.sessionStorage;
        if (!session) {
          // 会话缓存
          if (!Vue.prototype._session) {
            Vue.prototype._session = {};
          }
          session = Vue.prototype._session;
        }
        let ret = session[key];
        switch (ret) {
          case "true":
            ret = true;
            break;
          case "false":
            ret = false;
            break;
        }
        return ret;
      },
      pull_click() {
        this.showPrize = false
        if (this.prizeBg) {
          this.pullData();
        }
      },
      prizeBg_click() {
        grabRed({
            red_id: this.data.redPrice.red_id
          })
          .then((data) => {
            if (data.code == 10002) {
              this.$toast(data.data.msg);
            } else {
              this.prizeBg = true;
              this.money = data.money;
              this.describe = data.describe;
            }
          })
      },
      // 当前时间的格式化字符串
      timeTostring() {
        if (this.surplusPriceTime > 0) {
          this.sin = setInterval(() => {
            var secondTime = parseInt(this.surplusPriceTime); // 秒
            var minuteTime = 0; // 分
            var hourTime = 0; // 小时
            var dayTime = 0; // 天
            if (secondTime > 60) { //如果秒数大于60，将秒数转换成整数
              //获取分钟，除以60取整数，得到整数分钟
              minuteTime = parseInt(secondTime / 60);
              //获取秒数，秒数取佘，得到整数秒数
              secondTime = parseInt(secondTime % 60);
              //如果分钟大于60，将分钟转换成小时
              if (minuteTime > 60) {
                //获取小时，获取分钟除以60，得到整数小时
                hourTime = parseInt(minuteTime / 60);
                //获取小时后取佘的分，获取分钟除以60取佘的分
                minuteTime = parseInt(minuteTime % 60);
                if (hourTime > 24) {
                  //获取天，获取小时除以24，得到整数天
                  dayTime = parseInt(hourTime / 24);
                  //获取天后取佘的小时，获取小时除以24取佘的小时
                  hourTime = parseInt(hourTime % 24);
                }
              }
            }
            var result = ((secondTime < 10) ? "0" : "") + parseInt(secondTime);

            if (minuteTime > 0) {
              result = ((minuteTime < 10) ? "0" : "") + parseInt(minuteTime) + ":" + result;
            }
            if (hourTime > 0) {
              result = ((hourTime < 10) ? "0" : "") + parseInt(hourTime) + ":" + result;
            }
            if (dayTime > 0) {
              this.day = dayTime;
            } else {
              this.day = 0;
            }

            this.time = result;
            this.surplusPriceTime -= 1;
          }, 1000);
        } else {
          clearInterval(this.sin)
        }

      },
      pullData() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        coursedetail({
            bid: this.$route.query.bid
          })
          .then((data) => {
            this.ewm_img = xx;
            this.body_show = true;
            this.data = data;
            this.$toast.clear();
            this.sharetype = data.sharetype;
            this.bigqrcode = data.bigqrcode;
            this.scrabble = data.scrabble;
            document.title = data.bigcoursename;
            var date = new Date();
            var day = date.getDate();
            // 判断是否关注
            // if(!data.subscribe && data.buyList.length>0) {
            //   this.not_concern = true;
            // }
            //
            if (data.red_envelope) {
              this.set_session('bigqrcodeshow', data.red_envelope.qrcode_state == 0);
            }
            if (this.get_session('bigqrcodeshow') !== undefined) {
              data.bigqrcodeshow = this.get_session('bigqrcodeshow');
            }
            this.free_show = !data.bigqrcodeshow;
            this.is_red = !data.redType && data.redPrice != '' && data.redshow;
            if (!data.subscribe && data.qrcode.length > 0) {
              this.assistant_show = true;
              this.ewm_img = data.qrcode;
            }
            this.source = this.$route.query.source || '';
            this.timestamp = Date.parse(new Date()) / 1000;
            // 课程期数
            if (!data.list || data.list.length == 0) {
              this.cid = data.id;
              this.surplusPriceTime = 0;
              this.courseprice = 0;
              this.originalprice = 0;
              this.surplus = 0;
            } else {
              for (let arg of data.list) {
                if (arg.selected) {
                  this.surplusPriceTime = arg.surplusPriceTime;
                  this.courseprice = arg.courseprice;
                  this.originalprice = arg.originalprice;
                  this.surplus = arg.surplus;
                  this.radio = arg.id;
                  this.cid = String(arg.id);
                  this.begintime = arg.begintime;
                }
              };
            }
            this.timeTostring();
            this.showPrize = data.redType;
            if (this.data.shareinfo) {
              this.order_price = (this.originalprice * 100 - this.data.shareprice * 100) / 100;
            } else {
              if (this.is_red) {
                this.order_price = (this.originalprice * 100 - this.data.redPrice.use_money * 100) / 100;
              }
            }

            if (this.data.shareinfo) {
              this.order_group.push({
                name: "好友邀请",
                price: this.data.shareprice,
                id: ''
              })
            }
            if (this.is_red && this.data.otheractivity) {
              this.order_group.push({
                name: "红包折扣",
                price: this.data.redPrice.use_money,
                id: this.data.redPrice.use_id
              })
            }
            // 分享
            this.pdk = this.$route.query.pdk || '';
            this.aspx = this.$route.query.aspx || '';
            if (this.source) {
              this.routArg['source'] = this.source;
            }
            if (this.pdk) {
              this.routArg['pdk'] = this.pdk;
            }
            if (this.aspx) {
              this.routArg['aspx'] = this.aspx;
            }
            // 用户图像
            this.headImg = data.userdetail.headimgurl;
            this.cacheUserConfig = {
              pdk: data.pdk,
              aspx: data.aspx
            };
            shareCon("course", this);
            // 神策统计
            sensors.track('courseDetails', {
              classification: data.bigcoursename,
              classification_id: this.$route.query.bid,
              channel_name: this.source || '',
              course_id: this.cid,
              course_name: data.coursename,
              share_user_id: this.pdk || '',
              course_discount_price: data.courseprice,
              course_original_price: data.originalprice,
              course_starttime: data.begintime,
              // 新增
              course_user_type: data.ishavedbuy ? "已付费" : "未付费"
            })
          })

      },
      // 立即报名
      signHandle() {
        this.statistical("coursebtn");
        // 神策统计--点击立即报名按钮
        sensors.track('applyCourse', {
          apply_page_url: location.href,
          apply_page_title: this.data.bigcoursename,
          classification: this.data.bigcoursename,
          classification_id: this.$route.query.bid,
          course_id: this.cid,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime
        });
        // 把神策数据存到本地缓存
        let godPolicy = {
          course_id: this.cid,
          classification: this.data.bigcoursename,
          course_name: this.data.coursename,
          course_discount_price: this.data.courseprice,
          course_original_price: this.data.originalprice,
          course_starttime: this.data.begintime
        };
        setStorage('godPolicy', 'godPolicy', godPolicy);
        if (this.data.refunding) {
          this.$toast("有退款订单，不能购买！");
        } else {
          if ((this.data.shareinfo || this.is_red) && !this.share_show) {
            this.share_show = true;
          } else {
            if (this.data.mobilestatus) {
              // 是否需要验证验证码
              this.$refs.handle.need_verify = this.data.need_verify || false;
              // 判断用户手机号是否已验证
              this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
              this.$refs.handle.show = true;
            } else {
              this.$refs.handle.pay()
            }
          }

        }

      },
      // 本地统计
      statistical(data) {
        statistics({
          type: data
        }).then();
      },
      statistic_() {
        statistic_next({
            cid: this.data.id
          })
          .then();
      },
      // 免费试学
      free_learn() {
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        getproject({
            cid: this.cid
          })
          .then((data) => {
            this.toProjectHandle(data.projects[0].cpid);
            this.$toast.clear();
          }).catch((err) => {
            this.toProjectHandle();
            this.$toast.clear();
          });

      },
      // 跳转项目详情页
      toProjectHandle(cpid) {
        project_click_time({
          cid: this.cid
        }).then((data) => {
          // 免费试学跳转
          if (!this.data.bigqrcodeshow) {
            this.$router.push({
              path: '/project_details',
              query: {
                'cid': this.cid,
                'cpid': cpid,
                'pdk': this.routArg.pdk,
                'aspx': this.routArg.aspx,
                'source': this.routArg.source
              }
            });
          } else {
            this.big_show = true;
          }
        });
      },
      // 截取返回link中的地址中的路由名称
      url_substying(url_) {
        let index = url_.lastIndexOf('/');
        let last = url_.lastIndexOf('.');
        let x = url_.substring(index, last);
        return x
      }
    },
    created() {
      this.pullData();
    },
    destroyed() {
      clearInterval(this.sin)
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.Spring-Festival img{
  width:600px;
}
#index {
  background: url(../../../assets/details_bg_new.png);
  background-size: contain;
  padding-bottom: changeRem(2)+px;
}

.share {
  background-color: #EB5032;
  padding: 30px;
  h2 {
    font-size: 34px;
    color: #fff;
    text-align: center;
    span {
      max-width: 165px;
      display: inline-block;
      vertical-align: sub;
    }
  }
  img.close {
    width: 28px;
    float: right;
  }
  .share_per {
    width: 510px;
    margin: 0 auto;
    margin-top: 30px;
    .sp_l {
      width: 126px;
      float: left;
      text-align: center;
      img {
        width: 90px;
        border-radius: 50%
      }
      p {
        margin-top: 20px;
        color: #fff;
        font-size: 26px;
        width: 126px;
      }
    }
    img.lj_img {
      margin-top: 10px;
      width: 258px;
      float: left;
    }
  }
  .sp_b {
    width: 690px;
    height: 125px;
    background-image: url(../../../assets/sha3.png);
    background-size: cover;
    margin-top: 30px;
    position: relative;
    span {
      color: #EB5032;
      font-size: 38px;
      min-width: 140px;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 30px;
      span {
        font-size: 28px;
        position: static;
      }
    }
    .sp_br {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 30px;
      h3 {
        color: #EB5032;
        font-size: 28px;
        width: 420px;
        line-height: 40px;
      }
      h4 {
        color: #999999;
        font-size: 20px;
        line-height: 30px;
      }
    }
  }
}

.share_order {
  width: 100%;
  img {
    float: right;
    width: 28px;
    margin: 30px;
  }
  h2 {
    margin-top: 20px;
    color: #333;
    font-size: 34px;
    text-align: center;
    font-weight: bold;
  }
  h3 {
    color: #333;
    font-size: 26px;
    margin: 0 30px;
    margin-top: 40px;
    padding-bottom: 10px;
    border-bottom: 2px solid #ccc;
    margin-bottom: 40px;
    span {
      float: right;
    }
    .spec {
      color: #EB5032;
    }
  }
  h3.child {
    border-bottom: none;
    margin-top: 20px;
  }
  a.into_project {
    display: block;
    width: 100%;
    line-height: changeRem(1.96)+px;
    text-align: center;
    background: rgba(235, 80, 50, 1);
    text-align: center;
    color: #fff;
    margin-top: 40px;
    font-size: 34px;
  }
  a.into_project_over {
    background-color: #ccc
  }
}

// 课程的价格和开课时间
.money_box {
  border-radius: changeRem(.32)+px;
  margin: changeRem(-1.64)+px changeRem(.6)+px changeRem(1)+px;
  box-shadow: 0px 0px 14px 0px rgba(235, 80, 50, 0.1);
  background-color: #FFF;
  position: relative;
  padding: 0 changeRem(.6)+px changeRem(.8)+px;
  z-index: 1;
  .money_ {
    display: flex;
    padding-top: 35px;
    .money_left {
      margin-right: auto;
      font-size: changeRem(.52)+px;
      span {
        font-size: 44px;
        color: #EB5032;
      }
    }
    .money_right {
      margin-left: auto;
      font-size: changeRem(.48)+px;
      background-color: #EB5032;
      color: #FFF;
      position: relative;
      // height: changeRem(.6)+px;
      line-height: changeRem(.6)+px;
      align-self: center;
      padding: changeRem(.16)+px changeRem(.24)+px changeRem(.16)+px changeRem(.6)+px;
    }
    .money_time {
      margin-left: auto;
      font-size: 24px;
      color: #333;
      text-align: right;
      line-height: 40px;
      span {
        color: #EB5032;
      }
      a {
        display: inline-block;
        width: 120px;
        height: 26px;
        background: rgba(235, 80, 50, 1);
        border-radius: 4px;
        line-height: 26px;
        text-align: center;
        font-size: 24px;
        color: #fff;
      }
    }
    .money_time1 {
      line-height: 60px;
    }
    .money_right:after {
      position: absolute;
      content: "";
      width: 0;
      height: 0;
      left: changeRem(-.2)+px;
      top: changeRem(.25)+px;
      border-right: changeRem(.2)+px solid #EB5032;
      border-top: changeRem(.2)+px solid #FFF;
      border-bottom: changeRem(.2)+px solid #FFF;
    }
  }
  .date_ {
    background: #fff;
    border: 2px solid #EB5032;
    width: 300px;
    line-height: 70px;
    color: #EB5032;
    font-size: changeRem(.52)+px;
    margin-top: changeRem(.6)+px;
    text-align: center;
    float: left;
  }
  .date_:nth-child(odd) {
    float: right;
  }
  .date_over {
    border-color: #ccc;
    color: #999;
  }
  .date_now {
    background-color: #ccc;
    border-color: #ccc;
    color: #fff;
  }
}

.user_share {
  padding: 0;
  padding-right: changeRem(1)+px;
  padding-top: changeRem(0.8)+px;
  .scoure_name {
    padding-left: changeRem(0.7)+px;
  }
}

// 职业困扰
.problem_ {
  background-color: #F57F17;
  border-radius: changeRem(.32)+px;
  padding: changeRem(.4)+px changeRem(.2)+px;
  margin: 0 changeRem(.6)+px changeRem(1)+px;
  .problem_box {
    padding: changeRem(1)+px changeRem(.4)+px changeRem(1)+px;
    border-radius: changeRem(.32)+px;
    background-color: #FFF;
    h2.btb1 {
      font-size: changeRem(.68)+px;
      color: #333;
      text-align: center;
      line-height: changeRem(1.08)+px;
      display: flex;
      justify-content: center;
      flex-direction: column;
    }
    h2.btb1:after {
      content: '';
      height: changeRem(.48)+px;
      width: changeRem(9.16)+px;
      margin: changeRem(-.6)+px auto auto;
      background-color: rgba(245, 127, 23, .06);
    }
    h2.btb2 {
      font-size: changeRem(.68)+px;
      color: #333;
      font-weight: 700;
      text-align: center;
      display: flex;
      line-height: changeRem(1.08)+px;
      justify-content: center;
      flex-direction: column;
    }
    h2.btb2:after {
      content: '';
      height: changeRem(.48)+px;
      width: changeRem(10.64)+px;
      margin: changeRem(-.6)+px auto auto;
      background-color: rgba(245, 127, 23, .1);
    }
    .problem_list {
      text-align: center;
      display: flex;
      // flex-wrap: wrap;
      margin-top: changeRem(1)+px;
      .problem_child {
        width: changeRem(6.1)+px;
        padding: changeRem(.88)+px changeRem(.4)+px changeRem(.36)+px changeRem(.4)+px;
        background-color: rgba(245, 127, 23, .1);
        border-radius: changeRem(.08)+px;
        img {
          width: changeRem(1.44)+px;
          height: changeRem(1.44)+px;
        }
        p {
          font-size: changeRem(.52)+px;
          color: #333;
          line-height: changeRem(.64)+px;
          text-align: left;
          span {
            font-weight: 700;
          }
        }
      }
      .problem_child:nth-child(odd) {
        margin-right: changeRem(.4)+px;
      }
    }
    .p_list {
      margin-top: changeRem(.4)+px;
    }
    .problem_box_child {
      border: changeRem(.04)+px solid #F57F17;
      border-radius: changeRem(.2)+px;
      margin-top: changeRem(1.64)+px;
      padding: changeRem(.44)+px 0 0 0;
      line-height: 1;
      text-align: center;
      p {
        font-size: changeRem(.52)+px;
        color: #333;
        line-height: changeRem(1)+px;
        span {
          font-weight: 700;
        }
      }
      img {
        width: changeRem(.64)+px;
        height: changeRem(.64)+px;
        margin: changeRem(.64)+px auto;
      }
    }
    .need_box {
      color: #F57F17;
      height: changeRem(4.76)+px;
      margin-top: changeRem(.54)+px;
      padding-top: changeRem(.4)+px;
      border-radius: changeRem(.16)+px;
      text-align: center;
      h2 {
        font-size: changeRem(.56)+px;
        color: #FFF;
      }
      h3 {
        font-size: changeRem(.52)+px;
        line-height: changeRem(.92)+px;
        margin-top: changeRem(1.72)+px;
      }
    }
    .restore_box {
      background-color: #F2F2F2;
      padding: changeRem(.44)+px;
      margin-top: changeRem(1)+px;
      text-align: center;
      h2 {
        color: #333;
        font-weight: 700;
        font-size: changeRem(.68)+px;
        margin-bottom: changeRem(1.08)+px;
      }
      .restore_list {
        display: flex;
        justify-content: space-around;
        .restore_group {
          img {
            height: changeRem(2.68)+px;
          }
          h4 {
            font-size: changeRem(.52)+px;
          }
        }
      }
    }
    // 导师寄语
    h2.btb2.btb_new1 {
      font-size: changeRem(.6)+px;
      font-weight: 700;
    }
    h2.btb2.btb_new1:after {
      content: '';
      width: changeRem(8.16)+px;
    }
    h2.btb2.btb_new2 {
      font-size: changeRem(.6)+px;
      font-weight: 700;
    }
    h2.btb2.btb_new2:after {
      content: '';
      width: changeRem(12.4)+px;
    }
    .mentorInformation {
      display: flex;
      margin-top: changeRem(1)+px;
      img {
        width: changeRem(4.84)+px;
        height: changeRem(7.16)+px;
        margin-right: changeRem(.64)+px;
      }
      .mentorInformation_text {
        flex: 1;
        padding-top: changeRem(.76)+px;
        h3 {
          color: #F57F17;
          font-size: changeRem(.52)+px;
          text-align: left;
          margin-bottom: changeRem(.56)+px;
        }
        p {
          font-size: changeRem(.44)+px;
          text-align: left;
          line-height: changeRem(.64)+px;
          margin-bottom: changeRem(.4)+px;
        }
        p:last-child {
          margin-bottom: 0;
          letter-spacing: changeRem(-.008)+px;
        }
      }
    }
    .yhx {
      background-color: #F2F2F2;
      height: changeRem(.4)+px;
      border-radius: changeRem(.2)+px;
    }
    .dsjy {
      border-radius: changeRem(.2)+px;
      background-color: #F57F17;
      text-align: left;
      font-size: changeRem(.52)+px;
      padding: changeRem(.4)+px;
      margin-top: changeRem(.6)+px;
      p {
        color: #FFF;
      }
      p.pr {
        text-align: right;
      }
    }
    // PBL发展方向
    h2.btb2.btb_new3 {
      letter-spacing: changeRem(-.06)+px;
      text-align: center;
    }
    h2.btb2.btb_new3:after {
      content: '';
      width: changeRem(12.6)+px;
    }
    .direction_box_one {
      display: flex;
      justify-content: space-between;
      padding: changeRem(1.4)+px changeRem(2.2)+px changeRem(.52)+px;
      .direction_child {
        img {
          width: changeRem(2.38)+px;
          height: changeRem(2.38)+px;
        }
        h4 {
          font-size: changeRem(.52)+px;
          line-height: changeRem(.64)+px;
          color: #333;
          text-align: center;
          span {
            color: #F57F17;
          }
        }
      }
    }
    .direction_box_two {
      display: flex;
      justify-content: space-around;
      margin-bottom: changeRem(.4)+px;
      .direction_child {
        img {
          width: changeRem(2.38)+px;
          height: changeRem(2.38)+px;
        }
        h4 {
          font-size: changeRem(.52)+px;
          line-height: changeRem(.64)+px;
          color: #333;
          text-align: center;
          span {
            color: #F57F17;
          }
        }
      }
    }
    h2.fzjd {
      font-size: changeRem(.56)+px;
      color: #EB5032;
      text-align: left;
      margin-top: changeRem(1.2)+px;
      margin-bottom: changeRem(.6)+px;
      line-height: changeRem(.64)+px;
      img {
        width: changeRem(.36)+px;
        height: changeRem(.46)+px;
        margin-right: changeRem(.24)+px;
      }
    }
    .fzjd_box {
      h2 {
        color: #333;
        font-size: changeRem(.52)+px;
        text-align: left;
        margin-bottom: changeRem(.6)+px;
        font-weight: 700;
        line-height: changeRem(.64)+px;
      }
      p {
        color: #333;
        font-size: changeRem(.52)+px;
        text-align: left;
        line-height: changeRem(.72)+px;
      }
    }
    .development_ul {
      margin-top: changeRem(.84)+px;
      ul {
        li {
          display: flex;
          position: relative;
          .ul_border {
            height: 100%;
            width: changeRem(.04)+px;
            background-color: #F57F17;
            left: changeRem(.18)+px;
            position: absolute;
            top: changeRem(.68)+px;
            .bdf {
              display: block;
              width: changeRem(.4)+px;
              height: changeRem(.4)+px;
              border: changeRem(.04)+px solid #F57F17;
              box-sizing: border-box;
              border-radius: 50%;
              padding: .08rem;
              margin-left: changeRem(-.2)+px;
              margin-top: changeRem(.6)+px;
              position: relative;
              background-color: #FFF;
              .bdc {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translateY(-50%);
                display: block;
                width: changeRem(.24)+px;
                height: changeRem(.24)+px;
                border-radius: 50%;
                background-color: #F57F17;
                margin-left: changeRem(-.12)+px;
              }
            }
            .bdf.bd_one {
              margin-top: changeRem(-.2)+px;
            }
          }
          .development_ul_group {
            flex: 1;
            border-radius: changeRem(.2)+px;
            overflow: hidden;
            margin-left: changeRem(.7)+px;
            border: changeRem(.04)+px solid rgba(242, 242, 242, 1);
            margin-top: changeRem(.8)+px;
            h2 {
              background-color: #F2F2F2;
              color: #F57F17;
              font-size: changeRem(.52)+px;
              padding: changeRem(.36)+px changeRem(.44)+px;
              margin-bottom: changeRem(.6)+px;
              text-align: left;
            }
            p {
              padding: 0 changeRem(.36)+px;
              text-align: left;
              color: #333;
              span {
                font-weight: bold;
              }
            }
            p:last-child {
              padding-bottom: changeRem(.6)+px;
            }
          }
          .development_ul_group.no_mt {
            margin-top: 0;
          }
        }
        li:last-child {
          .ul_border {
            height: changeRem(.68)+px;
          }
        }
      }
      .direction_book_box {
        display: flex;
        .book_box_left {
          background-image: url(../../../assets/direction_book.png);
          background-size: 100% 100%;
          width: changeRem(6.54)+px;
          height: 376px;
          font-size: changeRem(.52)+px;
          color: #333;
          padding: changeRem(.6)+px changeRem(1.2)+px changeRem(1.2)+px changeRem(.4)+px;
          box-sizing: border-box;
          text-align: left;
          span {
            font-weight: bold;
          }
        }
        .book_box_right {
          flex: 1;
          margin-left: changeRem(.6)+px;
          display: flex;
          flex-direction: column;
          align-self: center;
          h3 {
            text-align: center;
            background-color: #F57F17;
            color: #FFF;
            height: changeRem(1.6)+px;
            line-height: changeRem(1.6)+px;
            border-radius: changeRem(.16)+px;
            font-size: changeRem(.56)+px;
            margin-bottom: changeRem(.6)+px;
          }
        }
      }
      .dir_box {
        margin-top: changeRem(.6)+px;
        img {
          height: changeRem(7.44)+px;
          width: 100%;
        }
        p {
          font-size: changeRem(.4)+px;
          color: #999;
          text-align: center;
        }
      }
      p.dir_box_two {
        font-size: changeRem(.52)+px;
        color: #333;
        margin-bottom: changeRem(.6)+px;
        text-align: left;
        span {
          font-weight: bold;
        }
      }
      .team_box {
        padding: changeRem(.64)+px changeRem(.64)+px changeRem(.6)+px changeRem(.64)+px;
        border: changeRem(.12)+px solid #F2F2F2;
        box-sizing: border-box;
        border-radius: changeRem(.2)+px;
        text-align: center;
        p {
          text-align: left;
          span {
            font-weight: bold;
          }
        }
        img {
          width: changeRem(8.52)+px;
          height: changeRem(6.32)+px;
        }
      }
      .tool_box {
        display: flex;
        flex-wrap: wrap;
        border-radius: changeRem(.2)+px;
        overflow: hidden;
        h3 {
          width: 50%;
          background: rgba(245, 127, 23, .1);
          color: #333;
          border-bottom: changeRem(.04)+px solid #FFF;
          box-sizing: border-box;
          font-size: changeRem(.52)+px;
          padding: changeRem(.54)+px 0;
          text-align: center;
        }
        h3:nth-child(odd) {
          border-right: changeRem(.04)+px solid #FFF;
        }
      }
    }
    // 往期学员告诉你
    .btb2.btb_new2_shs {
      margin-bottom: changeRem(3.16)+px;
    }
    .btb2.btb_new2_shs:after {
      width: changeRem(5.76)+px;
    }
    .student_box {
      position: relative;
      margin-bottom: changeRem(2.16)+px;
      img {
        position: absolute;
        width: changeRem(2.52)+px;
        height: changeRem(2.52)+px;
        border-radius: 50%;
        top: 0;
        left: 50%;
        transform: rotateX(-50%);
        margin-top: changeRem(-1.56)+px;
        margin-left: changeRem(-1.26)+px;
        z-index: 1;
      }
      .student_content {
        display: flex;
        flex-direction: column;
        border: changeRem(.08)+px solid rgba(245, 127, 23, 1);
        overflow: hidden;
        font-size: 0;
        border-radius: changeRem(.2)+px;
        .student_head {
          color: #FFF;
          background-color: #F57F17;
          position: relative;
          padding: 0 changeRem(.4)+px;
          font-size: changeRem(.48)+px;
          display: flex;
          h3 {
            font-size: changeRem(.48)+px;
            line-height: changeRem(1.08)+px;
          }
          h3.stu_r {
            margin-left: auto;
          }
        }
        .stu_content {
          padding: changeRem(.4)+px changeRem(.44)+px;
          font-size: changeRem(.48)+px;
          text-align: left;
          line-height: changeRem(.64)+px;
        }
      }
    }
    .student_box:last-child {
      margin-bottom: 0;
    }
  }
  // 课程适合谁
  .problem_box.shs {
    padding-bottom: changeRem(.6)+px;
    h2.btb2.btb_new1_shs {
      margin-bottom: changeRem(1.6)+px;
    }
    h2.btb2.btb_new1_shs:after {
      width: changeRem(4.16)+px;
    }
    p {
      font-size: changeRem(.52)+px;
      color: #F57F17;
      margin-bottom: changeRem(1.2)+px;
      line-height: 1;
      text-align: center;
    }
    p:last-child {
      margin-bottom: changeRem(.6)+px;
    }
  }
  // 加入我们
  .problem_box.join_us {
    text-align: center;
    p {
      line-height: 1;
      margin-bottom: changeRem(.6)+px;
      color: #333;
    }
    p:last-child {
      margin-bottom: changeRem(1.54)+px;
    }
    h2 {
      font-size: changeRem(.52)+px;
      line-height: 1;
      margin-bottom: changeRem(.6)+px;
    }
    h2.btb_new_join {
      margin-bottom: changeRem(1.4)+px;
    }
    h2.btb_new_join:after {
      width: changeRem(5.06)+px;
    }
    h3 {
      background-color: #F57F17;
      color: #FFF;
      border-radius: changeRem(.6)+px;
      font-size: changeRem(.52)+px;
      padding: changeRem(.36)+px 0;
      width: changeRem(7.8)+px;
      margin: 0 auto changeRem(.76)+px;
    }
    img {
      width: changeRem(.64)+px;
      height: changeRem(.64)+px;
    }
  }
}

// 常见问题
.common_box {
  padding: 0 changeRem(1.2)+px changeRem(1.56)+px;
  h2 {
    font-size: changeRem(.68)+px;
    color: #333;
    margin-bottom: changeRem(.44)+px;
    font-weight: bold;
    text-align: center;
  }
  ul {
    li {
      display: flex;
      text-align: left;
      margin-bottom: changeRem(.4)+px;
      img {
        width: changeRem(.6)+px;
        height: changeRem(.6)+px;
        margin-right: changeRem(.4)+px;
      }
      .common_box_text {
        h3 {
          font-size: changeRem(.48)+px;
          font-weight: bold;
          margin: 0 auto changeRem(.4)+px;
          line-height: 1;
        }
        p {
          font-size: changeRem(.48)+px;
          line-height: changeRem(.68)+px;
        }
      }
    }
  }
}

// 按钮
.into_btn_box {
  background: #fff;
  width: 100%;
  max-width: 750px;
  line-height: changeRem(1.96)+px;
  height: changeRem(1.96)+px;
  position: fixed;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  text-align: center;
  z-index: 2;
  font-size: changeRem(.68)+px;
  .into_project {
    display: block;
    width: 100%;
    line-height: changeRem(1.96)+px;
    text-align: center;
    background: rgba(235, 80, 50, 1);
    text-align: center;
    color: #fff;
  }
  .into_btn {
    display: flex;
    .into_btn_spe {
      display: flex;
      width: 100%;
    }
  }
  .free_learn {
    color: #EB5032;
    display: block;
    width: 214px;
    text-align: center;
  }
  .sign_immediately {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #EB5032;
    color: #fff;
  }
  .sign_immediately.only {
    position: relative;
    line-height: 18px;
    align-items: normal;
    padding-top: 25px;
    b {
      position: absolute;
      bottom: 15px;
      left: 0;
      width: 100%;
      text-align: center;
      font-weight: normal;
      font-size: 24px;
    }
  }
  .sign_immediately.only span {
    font-size: 24px;
  }
  .sign_immediatelys {
    background-color: #ccc;
  }
}

// 修改之
.scoure_name {
  font-size: 30px;
  color: #333333;
}


/* 红包 */

.prize-pop {
  background: rgba(0, 0, 0, 0);
  overflow-y: visible;
  overflow-x: visible;
}

.prize {
  transform: rotateY(0deg) translateY(-200%);
  animation: movelateY .5s forwards;
  color: #EECC8F;
  .bg {
    width: 8rem;
    position: relative;
    z-index: 1;
  }
  .close-btn {
    width: 28px;
    height: 28px;
    position: absolute;
    right: 32px;
    top: 32px;
    overflow-y: hidden;
    z-index: 2;
    background: url(../../../assets/Prize_close.png) top center;
    background-size: cover;
    p {
      width: 100%;
      border-bottom: 3px solid #AC0C11;
      position: absolute;
      left: 0;
      top: 0;
    }
    >p:nth-child(1) {
      transform: rotateZ(45deg);
      top: 10px;
    }
    >p:nth-child(2) {
      transform: rotateZ(-45deg);
      top: 10px;
    }
  }
  img {
    // position: absolute;
    left: 0;
    top: 0;
    width: 8rem;
    max-width: 100%;
  }
  .prize-btn {
    width: 160px;
    position: absolute;
    top: 455px;
    left: 50%;
    margin-left: -70px;
  }
  .row-public {
    width: 100%;
    text-align: center;
    position: absolute;
    span.num-type {
      font-size: 34px;
    }
  }
  .row-spe {
    top: 660px;
  }
  .text-tip {
    top: 210px;
    font-size: 34px;
    font-weight: bold;
  }
  .h1-head {
    top: 136px;
    font-size: 36px;
    font-weight: bold;
  }
  .greet {
    top: 189px;
    font-size: 36px;
    font-weight: bold;
  }
  .num {
    top: 289px;
    font-size: 34px;
    .h2-row {
      font-weight: bold;
      position: relative;
      font-size: 40px;
    }
    .size-sm {
      font-weight: normal;
      font-size: 24px;
      margin-top: 10px;
      position: relative;
    }
  }
  .reward_logo {
    width: 62px;
    position: absolute;
    left: 50%;
    margin-left: -31px;
  }
  .logo_top {
    top: 95px;
  }
  .logo_bottom {
    top: 579px;
  }
  .tip-footer {
    bottom: 44px;
    font-size: 34px;
    font-weight: bold;
  }
}

.prize.show {
  animation: rotate 1s forwards;
}

@keyframes movelateY {
  0% {
    transform: translateY(-200%);
  }
  100% {
    transform: translateY(0%);
  }
}

@keyframes rotate {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 44px 85px 34px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      // margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EB5032;
      }
    }
    h4 {
      margin-top: 16px;
      font-size: 24px;
      color: #666;
      line-height: 24px;
    }
  }
}
.spell {
  font-size: 28px;
  line-height: 34px;
  padding-top: 20px;
  text-align: center;
  padding-bottom: 10px;
  span {
    font-size: 20px;
    color: #999
  }
}
</style>
<style>
.money_box .radio_group {
  margin-bottom: 30px;
  width: 300px;
  line-height: 70px;
  /*height: 70px;*/
  text-align: center;
  color: #EB5032;
  font-size: 26px;
  border: 2px solid rgba(235, 80, 50, 1);
  float: left;
  position: relative;
}

.mev {
  margin-top: 50px
}

.money_box .radio_group:nth-child(even) {
  float: right;
}

.money_box .radio_group_over {
  color: #999999;
  border-color: #ccc
}

.money_box .radio_group:last-child {
  margin-bottom: 0;
}

.money_box .radio_group .van-radio {
  /*width: 100%;*/
  /*position: relative;*/
}

.money_box .radio_group .van-radio .van-radio__icon {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 36px;
  line-height: 36px;
}

.money_box .radio_group .van-radio .van-radio__icon .van-icon {
  border: none;
  background: none;
}

.money_box .radio_group .van-radio .van-radio__icon .van-icon:before {
  content: '';
}

.radio_group .van-radio .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success {
  width: 43px;
  height: 36px;
  background-image: url(../../../assets/radio_dw.png);
  background-size: cover;
  border-radius: 0;
  transition: .03s;
}

.money_box .radio_group .van-radio__label {
  line-height: 70px;
  text-align: center;
  color: #EB5032;
  margin-left: 0;
  font-size: 26px;
}

.money_box .radio_group_over .van-radio__label {
  color: #999
}

.order_group {
  color: #333;
  font-size: 26px;
  margin: 0 30px;
  line-height: 80px;
  text-align: left;
  position: relative;
}

.order_group:last-child {
  margin-top: 20px;
}

.order_group .van-radio .van-radio__icon {
  position: absolute;
  right: 0;
  top: 20px;
}

.order_group .van-radio__label {
  margin-left: 0;
}

.order_group .van-radio__label span {
  margin-left: 360px;
  color: #EB5032;
}

.van-radio__icon .van-icon {
  border: 2px solid #ccc;
}

.order_group .van-radio__icon--checked .van-icon {
  border-color: #EB5032;
  background-color: #EB5032;
}

.banq {
  font-size: 26px;
  color: #666;
  width: 100%;
  padding: 20px;
  text-align: justify;
}

</style>
